const getters = {
  lang: state => state.lang,
  wxState: state => state.wxState,
  token: state => state.token,
  userInfo: state => state.userInfo
}

export default getters
